export const promoBannerSizesMultiSelectTranslationKeys = {
  promoBannerSizesLabel: 'promo.banner-sizes-label',
}
